/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Billing_Extra_UsageInputs */



/**
* | output |
* | --- |
* | "Extra usage" |
*
* @param {Dashboard_Billing_Extra_UsageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_extra_usage = /** @type {((inputs?: Dashboard_Billing_Extra_UsageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Extra_UsageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusatznutzung")
	return /** @type {LocalizedString} */ ("Extra usage")
});